/* eslint-disable camelcase */
import { StorageKey } from '@/commons/constants'
import Vue from 'vue'
import * as types from './mutation-types'
export default {
  // 用户数据
  [types.UPDATE_USER] (state, datas) {
    // console.log('user datas', datas)
    state.user = datas

    if (!datas || datas.fail) {
      state.hasGetUser = true
      return false
    }

    try {
      if (datas.extraInfo) {
        console.log('datas.extraInfo', datas.extraInfo)
        const { vip_info: vipInfo } = datas
        const { isExpired, type, payType } = datas.extraInfo
        if (type !== 'common') {
          if (!isExpired) {
            state.isVip = true
            // 年会员
            if (vipInfo && vipInfo.ucenter_vip && vipInfo.ucenter_vip.vip_type === '年') {
              state.isYearVip = true
            }
            // 黑金会员
            if (type === 'vip' && payType === '黑金') {
              state.isBlackGoldVip = true
            }
            // 超级会员
            if (vipInfo &&
              vipInfo.ucenter_super &&
              vipInfo.ucenter_super.is_vip) {
              state.isSuperVip = true
            }
          }
        }
        if (type === 'elite' && !isExpired) {
          state.isEliteVip = true
        }
      } else {
        const getTime = (str) => new Date(str.replace(/-/g, '/')).getTime()
    // const vipExpiration = datas.vip_expiration
        if (datas.vip_info) {
          const { ucenter_elite, ucenter_vip } = datas.vip_info
          if (
        (ucenter_elite && getTime(ucenter_elite.expiration) > Date.now()) ||
        (ucenter_vip && getTime(ucenter_vip.expiration) > Date.now())
      ) {
            state.isVip = true
          }
        }
      }
      state.hasGetUser = true
    } catch (error) {
      state.hasGetUser = true
      console.log('login error', error)
    }
  },
  // 一些功能的配置
  [types.UPDATE_OPTIONS] (state, datas) {
    if (datas) {
      for (let name in datas) {
        Vue.set(state.options, name, datas[name])
      }
      state.hasGetOptions = true
    }
  },
  [types.UPDATE_LIVE_TYPE] (state, type) {
    state.liveType = type
  },
  [types.UPDATE_LIVE_INFO] (state, payload) {
    state.liveInfo = payload
  },
  [types.UPDATE_FETCH_APP_USER_DATA_STATE] (state, isFetchAppUserData) {
    state.isFetchAppUserData = isFetchAppUserData
  },
  [types.UPDATE_LIVE_URL] (state, url) {
    state.liveUrl = url
  },
  [types.UPDATE_LIVE_CURRENT_STATE] (state, isLive) {
    state.isLive = isLive
  },
  [types.UPDATE_CHAT_READY_STATE] (state, isReady) {
    state.chatReadyState = isReady
  },
  [types.CHECK_DEVICE] (state, isMobile) {
    state.isMobile = isMobile
  },
  [types.UPDATE_SERVER_TIME] (state, time) {
    state.serverTime = time * 1000
  },
  [types.UPDATE_POSTER_URL] (state, url) {
    state.posterUrl = url
  },
  [types.UPDATE_EMCEE] (state, name) {
    state.emcee = name
  },
  [types.UPDATE_VIDEO_ID] (state, id) {
    state.videoID = id
  },
  [types.UPDATE_TRADING_VIDEO_ID] (state, id) {
    state.tradingVideoID = id
  },
  [types.UPDATE_PREVUE_TIME] (state, time) {
    state.prevueTime = time
  },
  [types.UPDATE_CHANNEL_LIVE_STATE] (state, payload) {
    // console.log('UPDATE_CHANNEL_LIVE_STATE', payload)
    const channelLiveState = { ...state.channelLiveState }
    for (let key in payload) {
      channelLiveState[key] = payload[key]
    }
    // 重新赋值,保证修改对象里的值也能触发视图更新
    state.channelLiveState = channelLiveState
  },
  [types.UPDATE_FM_LIVE_PLAY_STATE] (state, isPlay) {
    state.fmLivePlayState = isPlay
  },
  [types.UPDATE_FM_REPLAY_STATE] (state, isPlay) {
    state.fmReplayState = isPlay
  },
  [types.UPDATE_FM_VIDEO] (state, payload) {
    for (let key in payload) {
      state.fmVideo[key] = payload[key]
    }
  },
  [types.UPDATE_FM_EMMEC_NOTICE] (state, notice) {
    state.fmEmmecNotice = notice
  },
  [types.UPDATE_FM_SIGN_VISIBLE] (state, isShow) {
    state.isShowFMSign = isShow
  },
  [types.UPDATE_WEEK_TALK_DATAS] (state, payload) {
    for (let key in payload) {
      Vue.set(state.weekTalkDatas, key, payload[key])
    }
  },

  [types.SET_PAGE_TYPE] (state, type) {
    state.pageType = type
  },
  [types.SET_VIP_STATE] (state, vip) {
    state.isVip = vip
  },
  [types.SET_TRY_FREE_REMAIN] (state, data) {
    const { id, time, uid } = data
    if (state.trySeeRemain[uid]) {
      state.trySeeRemain[uid][id] = time
    } else {
      state.trySeeRemain = {
        ...state.trySeeRemain,
        [uid]: {
          [id]: time
        }
      }
    }
    localStorage.setItem(StorageKey.TRY_SEE_CACHE, JSON.stringify(state.trySeeRemain))
  },
  [types.SET_SERVICE_QRCODE] (state, data) {
    state.serviceQRCodeConfig = data
  },
  [types.SET_LOCAL_TIME] (state) {
    state.localTime = Date.now()
  },
  [types.SET_TOP_NAVS] (state, data) {
    state.topNavs = data
  },
  [types.SET_WINDOW_WIDTH] (state, width) {
    state.windowWidth = width
  },
  [types.SET_HAS_BUY_DING] (state, hasBuyDing) {
    state.hasBuyDing = hasBuyDing
  },
  [types.SET_HAS_GET_DING_INFO] (state, bool) {
    state.hasGetDingInfo = bool
  },
  [types.SET_DING_SHOW_CONFIG] (state, data) {
    state.dingShowConfig = data
    state.hasGetDingShowConfig = true
  },
  [types.UPDATE_ROOM_INFO] (state, data) {
    state.chatRooms = data || {}
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js